import SharedSortableLists from './SharedSortableLists'
import CreativeDirectorAdDesignJobsIndex from './CreativeDirectorAdDesignJobsIndex'

class CreativeDirectorSortableAdJobsList extends SharedSortableLists {
  reactTableComponent() {
    return CreativeDirectorAdDesignJobsIndex;
  }

  defaultSortKey() {
    return "due"
  }

  sortData() {
    switch(this.sortKey) {
      case "due":
        return this.sortBy({attr: "due_at_raw"})
        break;
      case "deadline":
        return this.sortMulti([
          {attr: "deadline"},
          {attr: "due_at_raw", reverseNever: true},
          {attr: "index"}
        ])
        break;
      case "territory":
        return this.sortMulti([
          {attr: "territory"},
          {attr: "due_at_raw", reverseNever: true},
          {attr: "index"}
        ])
        break;
      case "designer":
        return this.sortMulti([
          {attr: "designer_initials"},
          {attr: "due_at_raw", reverseNever: true},
          {attr: "index"}
        ])
        break;
      case "size":
        return this.sortMulti([
          {attr: "raw_size"},
          {attr: "due_at_raw", reverseNever: true},
          {attr: "index"}
        ])
        break;
    }
  }
}

export default CreativeDirectorSortableAdJobsList
